import { gql } from '@apollo/client';

export const DELETE_NOTIFICATION_RULE_MUTATION = gql(/* GraphQL */ `
  mutation NotificationRules_DeleteOne($input: IdInput!) {
    NotificationRules_DeleteOne(input: $input) {
      success
    }
  }
`);

export const UPDATE_NOTIFICATION_RULE_MUTATION = gql`
  mutation NotificationRules_UpdateOne($input: NotificationRulesInputUpdateOne!) {
    NotificationRules_UpdateOne(input: $input) {
      id
    }
  }
`;

export const CREATE_NOTIFICATION_RULE_MUTATION = gql`
  mutation NotificationRules_CreateOne($input: NotificationRulesInputCreateOne!) {
    NotificationRules_CreateOne(input: $input) {
      id
    }
  }
`;

export const DUPLICATE_NOTIFICATION_RULE_MUTATION = gql(/* GraphQL */ `
  mutation NotificationRules_Duplicate($input: IdInput!) {
    NotificationRules_Duplicate(input: $input) {
      id
    }
  }
`);
